import React, { useState, useEffect } from "react";
import {
  Offcanvas,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,

} from "react-bootstrap";
import {
  DisplaySettingsOutlined,
  DeleteForeverOutlined,
  WallpaperOutlined,
  AddOutlined,
} from "@mui/icons-material";
import toast from "react-hot-toast";
import EmpresaReplicaPGI from "./editComponents/EmpresaReplicaPGI";
import useForm from "../../hooks/useForm";
import TinyMCE from "../../components/pgi/tinyMCE";
import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import useBusiness from "../../hooks/useBusiness";
import { idGenerator } from "../../helpers/idGenerator"

const BusinessPgi = () => {
  const {business, editBusiness, getAllBusiness} = useBusiness()
    const {
        values,
        setValues,
        handleInputChange,
      } = useForm({
        state: true,
        publish: false,
        visible: true,
        title: business?.title ? business?.title : '',
      });
  const [showEditProducto, setShowEditProducto] = useState(true);
  const [objectId, setObjectId] = useState(null)
  const [modalFor, setModalFor] = useState(null);
  const handleClose = () => setShowEditProducto(false);
  const handleShow = () => setShowEditProducto(true);

  
  // MODAL GALERIA
  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);
  
  const handleModalClick = (modalFor, objectId) => {
    setModalFor(modalFor)
    setObjectId(objectId)
    handleShowGaleria()
  }

  useEffect(() => {
    getAllBusiness();
  }, []);
  
  useEffect(() => {
    setValues(business);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [business])

  const handleAddStep = () => {
      setValues({
        ...values,
        sliderSecondary: [
          ...values.sliderSecondary,
          {
            _id: idGenerator(12),
            title: "",
            description: "",
            imageSliderBusiness: []
          }
        ],
  
      })
    }
  
    const handleStepInput = ({target}) => {
      setValues({
        ...values,
        sliderSecondary: values.sliderSecondary.map((step, i) => {
  
          if (step._id === target.id) {
            return {...step, [target.name]: target.value}
          }
          return step
        })
      })
    }
  
    const handleDeleteStep = (index) => {
      setValues({
        ...values,
        sliderSecondary: values.sliderSecondary.filter(
          (step, i) => i !== index
        )
      })
    }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      editBusiness(values);
    } catch (error) {
      toast.error("Error al actualizar la sección")
    }
  };

  return (
    <div id="wrapperEditBusiness" className="wrapperPgi">
      <button onClick={handleShow} className="basePgi__setttings-button">
        <DisplaySettingsOutlined />
      </button>
      <div className="card container containerPgi pt-3 pb-3">
        <EmpresaReplicaPGI />
      </div>

      {/* OFFCANVAS SETTING HOME*/}
      <Offcanvas
        show={showEditProducto}
        onHide={handleClose}
        placement="start"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>EDITAR SECCIÓN EMPRESA</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <form onSubmit={handleSubmit}>
              <button
                type="submit"
                className="settings_button-pleno news_button float-end"
              >
                GUARDAR
              </button>
              <div className="pgi__sidebar-container-items form-group w-100">

                <Modal
                  id="galleryModal"
                  className="modalContenedor__galeria"
                  show={showGaleria}
                  objectId={objectId}
                  onHide={handleCloseGaleria}
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <GaleriaPgiModal
                      editProduct={values}
                      setEditProduct={setValues}
                      stepId={objectId}
                      modalFor={modalFor}
                      handleCloseGaleria={handleCloseGaleria}
                    />
                  </Modal.Body>
                </Modal>
                <h3 className="basePgi__comments">Banner Principal</h3>
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      name="sliderPrimaryDescription"
                      id="sliderPrimaryDescription"
                      value={values?.sliderPrimaryDescription}
                      onChange={handleInputChange}
                      placeholder="..."
                      required
                      maxLength={200}
                      minLength={2}
                    />
                    <label htmlFor="link2">Destacado</label>
                  </div>

                  <div className="form-floating">
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imageBusiness")}
                    >
                      Imagen desktop
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Escritorio (.jpg, .png). Proporción 16:9.
                        Ancho máximo 2048px
                      </span>
                    </p>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imageBusiness_tablet")}
                    >
                      Imagen tablet
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Tablet (.webP, .jpg, .png). Proporción 4:3.
                        Ancho máximo 2048px
                      </span>
                    </p>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imageBusiness_mobile")}
                    >
                      Imagen mobile
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen Mobile (.webP, .jpg, .png). Proporción 9:16.
                        Ancho máximo 1200px
                      </span>
                    </p>
                  </div>

                <hr />
                <h3 className="basePgi__comments">Banner secundario</h3>
                <div className="form-floating">
                  <input
                    required
                    type="text"
                    className="form-control"
                    name="bannerBusinessTitle"
                    id="bannerBusinessTitle"
                    value={values?.bannerBusinessTitle}
                    onChange={handleInputChange}
                    placeholder="..."
                    maxLength={60}
                    minLength={2}
                  />
                  <label htmlFor="title">
                    Título
                  </label>
                  <p className="basePgi__comments">
                    <span>Máximo de caracteres: 60.</span>
                  </p>
                </div>

                <div className="form-floating">
                  <textarea
                    type="text"
                    className="form-control"
                    name="bannerBusinessDescription"
                    id="bannerBusinessDescription"
                    value={values?.bannerBusinessDescription}
                    onChange={handleInputChange}
                    placeholder="..."
                    required
                    maxLength={140}
                    minLength={2}
                  />
                  <label htmlFor="content">Descripción</label>
                  <p className="basePgi__comments">
                    <span>Máximo de caracteres: 140.</span>
                  </p>
                </div>

                <hr />
                <h3 className="basePgi__comments">Slider</h3>
                <fieldset className="pgi__sidebar-container-items">
                    <p className="basePgi__comments">
                      Desde aquí podrá cargar cada slider de la sección.
                    </p>
                    <div className="pgi__archivo pgi__install">
                      {values?.sliderSecondary && values?.sliderSecondary?.map((step, index) => {
                        return (
                          <>
                            <div className="input-group" key={step?._id}>
                              <label htmlFor="title">{index + 1}</label>
                              <input
                                type="text"
                                className="form-control"
                                name={`title`}
                                placeholder="Paso"
                                id={step?._id}
                                defaultValue={step?.title}
                                onChange={handleStepInput}
                                maxLength={90}
                                minLength={2}
                              />
                              <OverlayTrigger
                                key="1"
                                placement="top"
                                overlay={<Tooltip id="1">Eliminar</Tooltip>}>
                                <Button onClick={() => handleDeleteStep(index)}>
                                  <DeleteForeverOutlined />
                                </Button>
                              </OverlayTrigger>
                            </div>

                            <TinyMCE
                              id={step?._id}
                              values={step?.description}
                              handleInputChange={handleStepInput}
                              name={`description`}
                            />
                            
                            <Button
                              className="btn-form-pgi pgi__head-modules mb-5"
                              onClick={() =>
                                handleModalClick("sliderSecondary", step._id)
                              }>
                              Seleccionar imagen
                              <WallpaperOutlined />
                            </Button>
                          </>
                        )
                      })}

                    </div>
                    <OverlayTrigger
                      key="1"
                      placement="top"
                      overlay={<Tooltip id="1">Nuevo paso</Tooltip>}>
                      <Button
                        variant="light"
                        className="btn-form-pgi allW"
                        onClick={handleAddStep}>
                        <AddOutlined />
                      </Button>
                    </OverlayTrigger>
                  </fieldset>



                <hr />
                <h3 className="basePgi__comments">Bloque Imagen - Descripción</h3>
                <div className="form-floating">
                  <input
                    required
                    type="text"
                    className="form-control"
                    name="bloqueTitle"
                    id="bloqueTitle"
                    value={values?.bloqueTitle}
                    onChange={handleInputChange}
                    placeholder="..."
                    maxLength={60}
                    minLength={2}
                  />
                  <label htmlFor="title">
                    Título
                  </label>
                  <p className="basePgi__comments">
                    <span>Máximo de caracteres: 60.</span>
                  </p>
                </div>
                <p>Cuerpo principal del bloque</p>
                    <div className="form-floating">
                      {values &&
                      <TinyMCE
                        values={values?.bloqueDescription ? values?.bloqueDescription : ''}
                        handleInputChange={handleInputChange}
                        name={"bloqueDescription"}
                      />}

                    </div>
                    
                    <div className="form-floating">
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imageBloqueBusiness")}
                    >
                      Imagen desktop
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Escritorio (.jpg, .png). Proporción 16:9.
                        Ancho máximo 2048px
                      </span>
                    </p>
                    {/* <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imageBloqueBusiness_tablet")}
                    >
                      Imagen tablet
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Tablet (.webP, .jpg, .png). Proporción 4:3.
                        Ancho máximo 2048px
                      </span>
                    </p> */}
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imageBloqueBusiness_mobile")}
                    >
                      Imagen mobile
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen Mobile (.webP, .jpg, .png). Proporción 9:16.
                        Ancho máximo 1200px
                      </span>
                    </p>
                  </div>

              </div>
            </form>

          {/****************end lista productos *************************** */}
        </Offcanvas.Body>
      </Offcanvas>
      {/*offC slides */}
    </div>
  );
};

export default BusinessPgi;
